export enum FeedbackType {
  CRITIC = "Kritik",
  ERROR = "Fehler",
  QUESTION = "Frage",
  IDEA = "Idee",
  PRAISE = "Lob"
}
